"use client";

import React from "react";
import { MapPin, FileText, Download } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const documents = [{
  title: "Règlement officiel du tournoi (PDF)",
  url: "#"
}, {
  title: "Formulaire de décharge médicale (PDF)",
  url: "#"
}, {
  title: "Planning des matchs - Phase de poules (PDF)",
  url: "#"
}];
export default function TournamentDetails() {
  return <section id="détails-du-tournoi" className="py-24 lg:py-32 bg-background relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 items-center">
          
          {}
          <div className="lg:col-span-7 relative z-10 h-[400px] lg:h-[650px] border-2 border-primary/40 rounded-none shadow-lg shadow-primary/10 bg-muted overflow-hidden">
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647492/img/stadium_map_premium.png)] bg-cover bg-center grayscale opacity-60 mix-blend-multiply dark:mix-blend-screen"></div>
            
            {}
            <div className="absolute top-1/4 left-1/3 animate-pulse">
              <MapPin className="text-primary size-8 drop-shadow-md" strokeWidth={2} />
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <MapPin className="text-primary size-12 drop-shadow-lg" strokeWidth={2.5} />
              <div className="absolute inset-0 bg-primary/20 rounded-full blur-xl -z-10 scale-150"></div>
            </div>
            <div className="absolute bottom-1/3 right-1/4 animate-pulse" style={{
            animationDelay: "1s"
          }}>
              <MapPin className="text-primary size-8 drop-shadow-md" strokeWidth={2} />
            </div>
          </div>

          {}
          <div className="lg:col-span-5 relative z-20 lg:-ml-16 mt-8 lg:mt-0">
            <div className="bg-secondary text-secondary-foreground p-8 lg:p-12 shadow-2xl rounded-none border border-white/5">
              
              <h2 className="font-default text-4xl lg:text-5xl font-bold mb-6 text-white uppercase tracking-wider">
                Informations du Tournoi
              </h2>
              
              <p className="font-default text-secondary-foreground/80 mb-10 leading-relaxed text-lg">
                Rejoignez-nous pour l'événement le plus attendu de l'année. Retrouvez ci-dessous toutes les informations essentielles, le plan d'accès au stade et les documents nécessaires pour finaliser votre inscription et préparer votre équipe.
              </p>
              
              <div className="space-y-3 mb-12">
                <h3 className="font-default text-xl text-white uppercase tracking-wide mb-5 border-b border-white/10 pb-2">
                  Documents à télécharger
                </h3>
                
                {documents.map((doc, i) => <Link key={i} to={doc.url} className="flex items-center gap-4 group p-3 hover:bg-white/5 transition-colors rounded-none border border-transparent hover:border-white/10" data-index={i}>
                    <div className="bg-background/10 p-2 rounded-none">
                      <FileText className="text-primary size-5 stroke-[2px] group-hover:scale-110 transition-transform" />
                    </div>
                    <span className="text-sm font-default text-secondary-foreground/90 group-hover:text-white transition-colors flex-1">
                      {doc.title}
                    </span>
                    <Download className="text-primary/50 size-4 opacity-0 group-hover:opacity-100 transition-opacity -translate-x-2 group-hover:translate-x-0 duration-300" />
                  </Link>)}
              </div>
              
              <Button className="w-full sm:w-auto rounded-none bg-gradient-to-r from-primary to-yellow-500 text-primary-foreground hover:from-yellow-400 hover:to-primary border-none shadow-lg shadow-primary/20 relative overflow-hidden group h-14 px-10 text-lg font-bold uppercase tracking-wide">
                <span className="relative z-10">Payer l'inscription</span>
                <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:translate-x-full transition-transform duration-1000 ease-in-out z-0"></div>
              </Button>
              
            </div>
          </div>

        </div>
      </div>
    </section>;
}